<template>
	<div class="c-calendar" data-lenis-prevent>
		<div class="c-calendar__inner">
			<div class="c-calendar__header">
				<button class="c-calendar__prev" @click.prevent="$emit('goToPrevMonth')">
					<Svg id="arrow-full-left" />
				</button>
				<span class="o-title-5 c-calendar__month">{{ monthYear }}</span>
				<button class="c-calendar__next" @click.prevent="$emit('goToNextMonth')">
					<Svg id="arrow-full-right" />
				</button>
			</div>
			<div class="c-calendar__days">
				<span>D</span>
				<span>L</span>
				<span>M</span>
				<span>M</span>
				<span>J</span>
				<span>V</span>
				<span>S</span>
			</div>
			<div class="c-calendar__dates">
				<button v-for="d in days" :key="d.Ymd" :class="{
					'is-current-date': isToday(d.date),
					'is-in-range': isInRange(d),
					'is-first-in-range': calendarData.range.start != null && d.date.getTime() == calendarData.range.start.getTime(),
					'is-last-in-range': calendarData.range.end != null && d.date.getTime() == calendarData.range.end.getTime(),
					'is-other-month': d.isOtherMonth,
				}" @click.prevent="$emit('setRange', d)" @mouseover="$emit('setRange', d, true)"
					@mouseleave="$emit('setRange', { day: null }, true)">
					{{ d.day }}
				</button>
			</div>
		</div>
		<button class="c-filter-bar__filter__reset u-mt-md" @click.prevent="$emit('reset-filters')">
			<Svg id="refresh" />
			Réinitialiser
		</button>
	</div>
</template>

<script setup>
import { computed, watch, inject } from 'vue';
import Svg from '@/js/components/Svg.vue';

const calendarData = inject('calendarData');

const props = defineProps(['startDate', 'calendarData']);
const emit = defineEmits(['select-range', 'reset-filters', 'goToPrevMonth', 'goToNextMonth', 'setRange']);

watch(() => props.startDate, async (newValue) => {
	if (newValue == null) {
		calendarData.value.range.start = null;
		calendarData.value.range.end = null;
	}
});

const monthYear = computed(() => {
	return calendarData.value.firstDay.toLocaleString('fr-CA', {
		month: 'long',
		year: 'numeric',
	}).charAt(0).toUpperCase() +
		calendarData.value.firstDay.toLocaleString('fr-CA', {
			month: 'long',
			year: 'numeric',
		}).slice(1)
});

const daysInMonth = computed(() => {
	return (new Date(calendarData.value.firstDay.getFullYear(), calendarData.value.firstDay.getMonth() + 1, 0).getDate())
});
const firstDayOfWeek = computed(() => {
	return (new Date(calendarData.value.firstDay.getFullYear(), calendarData.value.firstDay.getMonth(), 1).getDay())
});
const lastDayOfWeek = computed(() => {
	return (new Date(calendarData.value.firstDay.getFullYear(), calendarData.value.firstDay.getMonth() + 1, 0).getDay())
});
const days = computed(() => {
	const daysArray = [];
	for (let i = 0; i < firstDayOfWeek.value; i++) {
		let day = new Date(calendarData.value.firstDay.getFullYear(), calendarData.value.firstDay.getMonth(), -firstDayOfWeek.value + i + 1).getDate();
		let date = new Date(calendarData.value.firstDay.getFullYear(), calendarData.value.firstDay.getMonth(), -firstDayOfWeek.value + i + 1);
		daysArray.push({
			day: day, Ymd: new Date(calendarData.value.firstDay.getFullYear(), calendarData.value.firstDay.getMonth(), -firstDayOfWeek.value + i + 1).toISOString().split('T')[0],
			date: date,
			isOtherMonth: isInRange({ date: date }) ? false : true,
		});
	}
	for (let i = 1; i <= daysInMonth.value; i++) {
		daysArray.push({
			day: i,
			Ymd: new Date(calendarData.value.firstDay.getFullYear(), calendarData.value.firstDay.getMonth(), i).toISOString().split('T')[0],
			date: new Date(calendarData.value.firstDay.getFullYear(), calendarData.value.firstDay.getMonth(), i),
		});
	}

	for (let i = 1; i <= 6 - lastDayOfWeek.value; i++) {
		let day = new Date(calendarData.value.firstDay.getFullYear(), calendarData.value.firstDay.getMonth() + 1, i).getDate();
		let date = new Date(calendarData.value.firstDay.getFullYear(), calendarData.value.firstDay.getMonth() + 1, i);
		daysArray.push({
			day: day,
			date: date,
			Ymd: new Date(calendarData.value.firstDay.getFullYear(), calendarData.value.firstDay.getMonth() + 1, i).toISOString().split('T')[0],
			isOtherMonth: isInRange({ date: date }) ? false : true,
		});
	}
	return daysArray;
})
const isInRange = (day) => {
	return calendarData.value.range.start != null && calendarData.value.range.end != null && day.date >= calendarData.value.range.start && day.date <= calendarData.value.range.end;
};
const isToday = (day) => {
	return day.getDate() === calendarData.value.now.getDate() && day.getMonth() === calendarData.value.now.getMonth() && day.getFullYear() === calendarData.value.now.getFullYear();
};

</script>
